// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  storageTokenKeyName: 'beemz-finance-accessToken',
  storageUserDataKeyName: 'beemz-finance-userData',
}
